import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';

import {
  DEFAULT_SEO_CONFIG,
  DEFAULT_SITE_DESCRIPTION,
  DEFAULT_SITE_TITLE,
} from '../../next-seo.config';
import { LegalHeader } from '../components/Header/LegalHeader';
import { TermsService } from '../components/Legal/TermsService';

const TermsServicePage: NextPage = () => {
  const TERMS_SERVICE_DESCRIPTION = `Terms of Service| ${DEFAULT_SITE_DESCRIPTION}`;
  const TERMS_SERVICE_TITLE = `Terms of Service | ${DEFAULT_SITE_TITLE}`;
  return (
    <>
      <NextSeo
        {...DEFAULT_SEO_CONFIG}
        title={TERMS_SERVICE_TITLE}
        canonical="https://matcha.xyz/terms"
        description={TERMS_SERVICE_DESCRIPTION}
        openGraph={{ siteName: TERMS_SERVICE_TITLE, description: TERMS_SERVICE_DESCRIPTION }}
      />{' '}
      <LegalHeader />
      <TermsService />
    </>
  );
};

export default TermsServicePage;
